import { render, staticRenderFns } from "./CustomInputLabel.vue?vue&type=template&id=cc2658ca&"
import script from "./CustomInputLabel.vue?vue&type=script&lang=js&"
export * from "./CustomInputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports